// extracted by mini-css-extract-plugin
export default {"image":"Image_image__npSCr"};